import stubClient from './stubClient';
/**
 * The browser implementation is a stub that implements the DatadogClient
 * interface but does not actually report any metrics.
 */

export default stubClient;